import { create } from "zustand";

interface SessionState {
  sessionId: string | null;
  subject: string | null;
  topic: string | null;
  startedAt: number | null;
  start: (subject: string, topic: string) => void;
  end: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  sessionId: null,
  subject: null,
  topic: null,
  startedAt: null,
  start: (subject, topic) =>
    set({ sessionId: crypto.randomUUID(), subject, topic, startedAt: Date.now() }),
  end: () => set({ sessionId: null, subject: null, topic: null, startedAt: null }),
}));
